import styled from 'styled-components';
import { Color } from '../../../../common/view/color/color';
import { FontWeight } from '../../../../common/view/font';
import { FontSize } from '../../../../common/view/font/font-size';

const Container = styled.div.withConfig({
  componentId: 'today_done_container',
  displayName: 'TodayDone.Container',
})`
  padding: 10px;
`;

const Text = styled.div.withConfig({
  componentId: 'today_done_text',
  displayName: 'TodayDone.Text',
})`
  font-size: ${FontSize.l1};
  color: ${Color.white5};
`;

const NumberText = styled.div.withConfig({
  componentId: 'today_done_number_text',
  displayName: 'TodayDone.NumberText',
})<{ $animate?: boolean }>`
  font-size: 36px;
  font-weight: ${FontWeight.l1};
  color: ${Color.white5};

  @keyframes numberPop {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }

  animation: ${(props) => (props.$animate ? 'numberPop 0.3s ease-in-out' : 'none')};
`;

export const TodayDoneStyle = {
  Container,
  Text,
  NumberText,
};
